import t from"react";import{MdIcon as e}from"./MdIcon.js";import{mdiUnfoldMoreHorizontal as o}from"@mdi/js";const r=({id:r="expand",title:i="Expand",...m})=>t.createElement(e,{id:r,title:i,path:o,...m});export{r as ExpandIcon};
